/** @format */

import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { scrollToId, scrollToId2 } from "../../../../Helpers";
function AddedOrRemoveCor({
  setAddedCoord,
  setRemovedCoord,
  pdfPagesRef,
  pdfPages,
  containerRef,
}) {
  const { selectedDocument } = useSelector((state) => state.uploadDocument);
  const { coordinates } = useSelector((state) => state.pdfCoordinates);
  const orginalCoordinates = selectedDocument?.document_template;

  function extractCoordinatesFromObject(dataObj) {
    let coordinates = [];

    // Iterate over each page in the object
    for (const [page, fields] of Object.entries(dataObj)) {
      // Extract coordinates from each field type (textField, imageField, etc.)
      for (const [fieldType, fieldArray] of Object.entries(fields)) {
        for (const field of fieldArray) {
          coordinates.push({
            ...field,
            pageNumber: page, // Include page number for easier tracking
            fieldType: fieldType, // Store field type as well
          });
        }
      }
    }
    return coordinates;
  }

  // Helper function to compare coordinates based on id
  function compareCoordinates(originalCoordinates, newCoordinates) {
    const originalIds = new Set(originalCoordinates.map((item) => item?.id));
    const newIds = new Set(newCoordinates.map((item) => item?.id));

    // Find added coordinates (present in new array but not in original)
    const addedCoordinates = newCoordinates.filter(
      (item) => !originalIds.has(item?.id)
    );

    // Find removed coordinates (present in original object but not in new array)
    const removedCoordinates = originalCoordinates.filter(
      (item) => !newIds.has(item?.id)
    );

    return {
      addedCoordinates,
      removedCoordinates,
    };
  }

  // Step 1: Extract all original coordinates from the nested object
  const originalCoordinatesfunc =
    extractCoordinatesFromObject(orginalCoordinates);

  // Step 2: Compare the original and new coordinates
  const { addedCoordinates, removedCoordinates } = compareCoordinates(
    originalCoordinatesfunc,
    coordinates
  );

  useEffect(() => {
    console.log("added coordinates", addedCoordinates);
    console.log("removed coordinates", removedCoordinates);
    if (addedCoordinates?.length) {
      setAddedCoord(addedCoordinates?.length);
    }
    if (removedCoordinates?.length) {
      setRemovedCoord(removedCoordinates?.length);
    }
  }, [addedCoordinates, removedCoordinates]);

  return (
    <>
      <DialogTitle>Changed Coordinates</DialogTitle>
      <hr style={{ width: "100%", margin: 0 }} />
      <DialogContent
        sx={{
          width: "400px",
          height: "300px",
          background: "white",
          overflow: "auto",
        }}
      >
        {addedCoordinates?.length > 0 && (
          <p style={{ fontWeight: "bold", color: "green" }}>
            Added Coordinates
          </p>
        )}
        {addedCoordinates?.length > 0
          ? addedCoordinates?.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    scrollToId(
                      `page-${item?.pageNumber}`,
                      pdfPages,
                      containerRef
                    )
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      Page: {item?.pageNumber}
                    </p>
                    <p
                      style={{
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      Name: {item?.fieldValue || item?.fieldType || item?.value}
                    </p>
                  </div>
                </div>
              );
            })
          : "No Added Coordinates"}
        {removedCoordinates?.length > 0 && (
          <p style={{ fontWeight: "bold", color: "red" }}>
            Removed Coordinates
          </p>
        )}
        {removedCoordinates?.length > 0
          ? removedCoordinates?.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    scrollToId(
                      `page-${item?.pageNumber}`,
                      pdfPages,
                      containerRef
                    )
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      Page: {item?.pageNumber}
                    </p>
                    <p
                      style={{
                        fontWeight: "bold",
                        margin: 0,
                      }}
                    >
                      Name: {item?.fieldValue || item?.fieldType || item?.value}
                    </p>
                  </div>
                </div>
              );
            })
          : "No Removed Coordinates"}
      </DialogContent>
    </>
  );
}

export default AddedOrRemoveCor;
